import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { TournamentDetails } from 'actions/actionTypes';
import * as actions from 'actions/tournament/details';

import {
  callTournamentDetails,
  callTournamentRanking,
  callTournamentTotalRanking,
  callTournamentAwardRecipientsList,
  callExceptTournamentParticipantsCourseAward,
  callExceptTournamentParticipantsTotalAward,
  callTournamentParticipantAdditionalHandicapSettings,
  callResetTournamentAwards,
  calltournamentAwardRecipientsSelection,
  callTournamentAwardAnnouncement,
} from 'network/apis/tournament/details';
import { TOURNAMENT_GRADE_DATA } from 'utils/constants';

// 매장 대회 상세보기 조회 사가 함수
function* loadTournamentDetailsRequestSaga() {
  try {
    const tournamentDetails = yield select((state) => state.tournamentDetails);

    const response = yield call(callTournamentDetails, tournamentDetails.tournamentId);

    if (response?.data) {
      let tempData = { ...response.data };
      if (tempData?.participationGrades?.length > 0) {
        const list = TOURNAMENT_GRADE_DATA.reduce((acc, curr) => {
          const tempCurr = curr.reduce((subAcc, subCurr) => {
            let tempNode = { ...subCurr };
            const idx = tempData.participationGrades.findIndex((iNode) => iNode.gradeType === tempNode.gradeType && iNode.stepType === tempNode.stepType);
            if (idx > -1 && tempData.participationGrades[idx].isParticipation) {
              tempNode = { ...tempNode, ...tempData.participationGrades[idx] };
              subAcc.push(tempNode);
            }

            return subAcc;
          }, []);

          if (tempCurr?.length > 0) {
            acc.push(tempCurr);
          }

          return acc;
        }, []);
        tempData = { ...tempData, participationGrades: list };
      }

      yield put(actions.loadTournamentDetailsRequestSuccess(tempData));
    }
  } catch (error) {
    yield put(actions.loadTournamentDetailsRequestFailure(error.message));
  }
}

// 매장 대회 랭킹 조회 사가 함수
function* tournamentRankingRequestSaga() {
  try {
    const tournamentDetails = yield select((state) => state.tournamentDetails);

    const data = {
      page: tournamentDetails.ranking.currentPage,
      pageSize: tournamentDetails.ranking.pageSize,
      nickname: tournamentDetails.ranking.nickname,
      isAward: tournamentDetails.ranking.isAward,
      gender: tournamentDetails.ranking.gender,
      rankingSort: tournamentDetails.ranking.rankingSort,
    };

    let recordType = tournamentDetails.ranking.awardItem !== 'Score' ? tournamentDetails.ranking.awardItem : tournamentDetails.ranking.awardType;

    if(tournamentDetails.ranking.courseId !== '') {
      const response = yield call(callTournamentRanking, tournamentDetails.tournamentId, recordType, tournamentDetails.ranking.courseId, data);

      yield put(actions.loadTournamentRankingRequestSuccess(response.data));
    }
  } catch (error) {
    yield put(actions.loadTournamentRankingRequestFailure(error.message));
  }
}

// 매장 대회 전체 랭킹 조회 사가 함수
function* tournamentTotalRankingRequestSaga() {
  try {
    const tournamentDetails = yield select((state) => state.tournamentDetails);
    let response;

    const data = {
      page: tournamentDetails.ranking.currentPage,
      pageSize: tournamentDetails.ranking.pageSize,
      nickname: tournamentDetails.ranking.nickname,
      isAward: tournamentDetails.ranking.isAward,
      gender: tournamentDetails.ranking.gender,
      rankingSort: tournamentDetails.ranking.rankingSort,
    };

    let recordType =
      tournamentDetails.ranking.awardItem === 'HoleInOne' || tournamentDetails.ranking.awardItem === 'CourseRoundPlayCount'
        ? tournamentDetails.ranking.awardItem
        : tournamentDetails.ranking.awardType;

    if(tournamentDetails.ranking.courseId !== '') {
      if(tournamentDetails.ranking.awardItem === 'HoleInOne' || tournamentDetails.ranking.awardItem === 'CourseRoundPlayCount') {
        response = yield call(callTournamentTotalRanking, tournamentDetails.tournamentId, recordType, data);
      } else {
        if(tournamentDetails.ranking.isAward && (tournamentDetails.ranking.awardType === 'Stroke' || tournamentDetails.ranking.awardType === 'NewPerio')) {
          response = yield call(callTournamentRanking, tournamentDetails.tournamentId, recordType, 'ALLAWARD', data);
        } else {
          response = yield call(callTournamentRanking, tournamentDetails.tournamentId, recordType, 'ALL', data);
        }
      }

      yield put(actions.loadTournamentRankingRequestSuccess(response.data));
    }
  } catch (error) {
    yield put(actions.loadTournamentRankingRequestFailure(error.message));
  }
}

// 매장 대회 수살자 목록 조회 사가 함수
function* tournamentAwardRecipientsListRequestSaga() {
  try {
    const tournamentDetails = yield select((state) => state.tournamentDetails);

    const response = yield call(callTournamentAwardRecipientsList, tournamentDetails.tournamentId);

    yield put(actions.loadTournamentAwardRecipientsRequestSuccess(response.data));
  } catch (error) {
    yield put(actions.loadTournamentAwardRecipientsRequestFailure(error.message));
  }
}

// 매장 대회 코스별 시상 제외 사가 함수
function* exceptTournamentParticipantsCourseAwardRequestSaga() {
  try {
    const tournamentDetails = yield select((state) => state.tournamentDetails);

    const data = {
      isAwardExcept: tournamentDetails.ranking.awardExceptData.isAwardExcept,
    };

    const response = yield call(
      callExceptTournamentParticipantsCourseAward,
      tournamentDetails.tournamentId,
      tournamentDetails.ranking.awardExceptData.recordType,
      tournamentDetails.ranking.awardExceptData.tournamentParticipantId,
      data
    );

    yield put(actions.exceptTournamentParticipantsCourseAwardRequestSuccess(response.data));
  } catch (error) {
    yield put(actions.exceptTournamentParticipantsCourseAwardRequestFailure(error.message));
  }
}

function* allExceptTournamentParticipantsCourseAwardRequestSaga() {
  try {
    const tournamentDetails = yield select((state) => state.tournamentDetails);

    const data = {
      isAwardExcept: tournamentDetails.ranking.awardExceptData.isAwardExcept,
    };

    yield all(
      tournamentDetails.ranking.awardExceptData.tournamentParticipantIds.map((item) =>
        call(callExceptTournamentParticipantsCourseAward, tournamentDetails.tournamentId, tournamentDetails.ranking.awardExceptData.recordType, item, data)
      )
    );

    yield put(actions.allExceptTournamentParticipantsCourseAwardRequestSuccess());
  } catch (error) {
    yield put(actions.allExceptTournamentParticipantsCourseAwardRequestFailure(error.message));
  }
}

// 매장 대회 종합 시상 제외 사가 함수
function* exceptTournamentParticipantsTotalAwardRequestSaga() {
  try {
    const tournamentDetails = yield select((state) => state.tournamentDetails);

    const data = {
      isAwardExcept: tournamentDetails.ranking.awardExceptData.isAwardExcept,
    };

    const response = yield call(
      callExceptTournamentParticipantsTotalAward,
      tournamentDetails.tournamentId,
      tournamentDetails.ranking.awardExceptData.recordType,
      tournamentDetails.ranking.awardExceptData.userGuid,
      data
    );

    yield put(actions.exceptTournamentParticipantsTotalAwardRequestSuccess(response.data));
  } catch (error) {
    yield put(actions.exceptTournamentParticipantsTotalAwardRequestFailure(error.message));
  }
}

function* allExceptTournamentParticipantsTotalAwardRequestSaga() {
  try {
    const tournamentDetails = yield select((state) => state.tournamentDetails);

    const data = {
      isAwardExcept: tournamentDetails.ranking.awardExceptData.isAwardExcept,
    };

    yield all(
      tournamentDetails.ranking.awardExceptData.userGuids.map((item) =>
        call(callExceptTournamentParticipantsTotalAward, tournamentDetails.tournamentId, tournamentDetails.ranking.awardExceptData.recordType, item, data)
      )
    );

    yield put(actions.allExceptTournamentParticipantsTotalAwardRequestSuccess());
  } catch (error) {
    yield put(actions.allExceptTournamentParticipantsTotalAwardRequestFailure(error.message));
  }
}

// 매장 대회 참가자 추가 핸디캡 설정 사가 함수
function* tournamentParticipantAdditionalHandicapSettingsRequestSaga() {
  try {
    const tournamentDetails = yield select((state) => state.tournamentDetails);

    const data = {
      additionalHandicap: tournamentDetails.ranking.awardExceptData.additionalHandicap,
    };

    const response = yield call(
      callTournamentParticipantAdditionalHandicapSettings,
      tournamentDetails.tournamentId,
      tournamentDetails.ranking.awardExceptData.recordType,
      tournamentDetails.ranking.awardExceptData.tournamentParticipantId,
      data
    );

    yield put(actions.tournamentParticipantAdditionalHandicapSettingsRequestSuccess(response.data));
  } catch (error) {
    yield put(actions.tournamentParticipantAdditionalHandicapSettingsRequestFailure(error.message));
  }
}

// 매장 대회 시상 초기화 사가 함수
function* resetTournamentAwardsRequestSaga() {
  try {
    const tournamentDetails = yield select((state) => state.tournamentDetails);

    const response = yield call(callResetTournamentAwards, tournamentDetails.tournamentId);

    yield put(actions.resetTournamentAwardsRequestSuccess(response.data));
  } catch (error) {
    yield put(actions.resetTournamentAwardsRequestFailure(error.message));
  }
}

// 매장 대회 수살자 설정 사가 함수
function* tournamentAwardRecipientsSelectionRequestSaga() {
  try {
    const tournamentDetails = yield select((state) => state.tournamentDetails);

    const response = yield call(calltournamentAwardRecipientsSelection, tournamentDetails.tournamentId);

    yield put(actions.tournamentAwardRecipientsSelectionRequestSuccess(response.data));
  } catch (error) {
    yield put(actions.tournamentAwardRecipientsSelectionRequestFailure(error.message));
  }
}

// 매장 대회 시상 발표 사가 함수
function* tournamentAwardAnnouncementRequestSaga() {
  try {
    const tournamentDetails = yield select((state) => state.tournamentDetails);

    const data = {
      isAwardAnnouncement: true,
    };

    const response = yield call(callTournamentAwardAnnouncement, tournamentDetails.tournamentId, data);

    yield put(actions.tournamentAwardAnnouncementRequestSuccess(response.data));
  } catch (error) {
    yield put(actions.tournamentAwardAnnouncementRequestFailure(error.message));
  }
}

// Sign-In Sagas
export default function* root() {
  yield all([
    takeLatest(TournamentDetails.LOAD_TOURNAMENT_DETAILS_REQUEST, loadTournamentDetailsRequestSaga),
    takeLatest(TournamentDetails.LOAD_TOURNAMENT_RANKING_REQUEST, tournamentRankingRequestSaga),
    takeLatest(TournamentDetails.LOAD_TOURNAMENT_TOTAL_RANKING_REQUEST, tournamentTotalRankingRequestSaga),
    takeLatest(TournamentDetails.LOAD_TOURNAMENT_AWARD_RECIPIENTS_REQUEST, tournamentAwardRecipientsListRequestSaga),
    takeLatest(TournamentDetails.EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST, exceptTournamentParticipantsCourseAwardRequestSaga),
    takeLatest(TournamentDetails.ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST, allExceptTournamentParticipantsCourseAwardRequestSaga),
    takeLatest(TournamentDetails.EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST, exceptTournamentParticipantsTotalAwardRequestSaga),
    takeLatest(TournamentDetails.ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST, allExceptTournamentParticipantsTotalAwardRequestSaga),
    takeLatest(TournamentDetails.TOURNAMENT_PARTICIPANTS_ADDITIONAL_HANDICAP_SETTING_REQUEST, tournamentParticipantAdditionalHandicapSettingsRequestSaga),
    takeLatest(TournamentDetails.RESET_TOURNAMENT_AWARDS_REQUEST, resetTournamentAwardsRequestSaga),
    takeLatest(TournamentDetails.TOURNAMENT_AWARD_RECIPIENTS_SELECTION_REQUEST, tournamentAwardRecipientsSelectionRequestSaga),
    takeLatest(TournamentDetails.TOURNAMENT_AWARD_ANNOUNCEMENT_REQUEST, tournamentAwardAnnouncementRequestSaga),
  ]);
}
